/** Matches API `SourceActivityDetailApiModel` / `RegSourceActivity` JSON (camelCase). */
export interface ISourceActivityDetail {
    id: string;
    code: string;
    description: string;
    isActive: boolean;
    isDeleted: boolean;
    source: string;
    sourceVersion: string;
    effectiveFromUtc: string;
    createdAtUtc: string;
    updatedAtUtc: string;
    createdByDisplayName?: string | null;
    lastUpdatedByDisplayName?: string | null;
    deletedAuditAtUtc?: string | null;
    deletedByDisplayName?: string | null;
    disabledAuditAtUtc?: string | null;
    disabledByDisplayName?: string | null;
}

export type SourceActivityCreatePayload = {
    code: string;
    description: string;
    isActive?: boolean;
};

export type SourceActivityUpdatePayload = {
    id: string;
    code: string;
    description: string;
};

export const SOURCE_ACTIVITY_CREATE_CONFLICT = {
    deletedRestoreAvailable: "sourceActivity.deletedRestoreAvailable",
    duplicateActive: "sourceActivity.duplicateActive",
} as const;

